'use client';

import { useTranslation } from './i18n-context';
import { Avatar } from './avatar';
import { Button } from './button';
import { EmptyState } from './empty-state';
import styles from './temporary-error-screen.module.css';

/**
 * GEÇİCİ HATA sınırı — `TemporaryErrorScreen`in İSTEMCİ eşi (tech-lead
 * 17B+17E Yüksek-1). Sunucu sürümü sayfa yeniden yüklenerek denenir; burada
 * denenecek şey OTURUM DİRİLTMEDİR, o yüzden bağlantı değil eylem verilir.
 *
 * Nerede çizilir: `sessionUndecided` — yani sunucu 429/5xx döndüğü ya da ağ
 * koptuğu için oturum hakkında KARAR VERİLEMEDİĞİ durumda. Kullanıcı girişe
 * ATILMAZ (jeton HttpOnly çerezde canlı) ve içerik de çizilmez (fail-closed).
 *
 * Görünüm README 4.7 boş/hata deseni: kicker + başlık + gövde + numaralı adım
 * + TEK dolu eylem + ürünün kendi satırının soluk önizlemesi. Ekranda etkinlik
 * ya da kurum adı GEÇMEZ; karar verilmemişken bağlam sızmaz.
 */
export function TemporaryErrorPanel({ onRetry }: { onRetry: () => void }) {
  const t = useTranslation();

  return (
    <div className={styles.page}>
      <EmptyState
        kicker={t.t('temporaryError.kicker')}
        title={t.t('temporaryError.title')}
        body={t.t('temporaryError.body')}
        steps={[
          { title: t.t('temporaryError.stepRetry'), body: t.t('temporaryError.stepRetryBody') },
        ]}
        action={
          <Button variant="primary" onClick={onRetry}>
            {t.t('temporaryError.action')}
          </Button>
        }
        previewLabel={t.t('temporaryError.previewLabel')}
        preview={
          <div className={styles.row}>
            <Avatar name={t.t('common.appTagline')} size="md" shape="entity" />
            <span className={styles.rowBody}>
              <span className={styles.rowTitle}>{t.t('common.appTagline')}</span>
              <span className={styles.rowMeta}>{t.t('temporaryError.previewLabel')}</span>
            </span>
          </div>
        }
      />
    </div>
  );
}
